import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { Container, Row, Col } from 'react-bootstrap'

import { ButtonAnalytics, Layout } from '../components/common'
import { MetaData } from '../components/common/meta'

/**
 * Single page (/:slug)
 *
 * This file renders a single page and loads all the content.
 *
 */
const Career = ({ data, location }) => {
    const page = data.lever

    return (
        <>
            <MetaData
                data={data}
                location={location}
                type="website"
                title={page.text}
                description={page.descriptionPlain.substr(0, 150)}
            />
            <Layout>
                <section className="page-general career">
                    <Container>
                        <Row>
                            <Col>
                                <h1>
                                    {page.text}
                                </h1>
                                <div className="sub-title">
                                    {page.categories.team} - {page.categories.location} / {page.categories.commitment}
                                </div>
                                <article>
                                    <section className="career-content">
                                        <div dangerouslySetInnerHTML={{ __html: page.description }} />
                                        {page.lists.map((obj, index) => (
                                            <div key={index}>
                                                <h2>{obj.text}</h2>
                                                <div dangerouslySetInnerHTML={{ __html: obj.content }} />
                                            </div>
                                        ))}
                                        <div className="apply-job">
                                            <ButtonAnalytics
                                                href={page.applyUrl}
                                                target="_blank"
                                                variant="primary"
                                                size="lg"
                                                action_name="Start for Free"
                                            >
                                            Apply for this job
                                            </ButtonAnalytics>
                                        </div>
                                    </section>
                                </article>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Layout>
        </>
    )
}

Career.propTypes = {
    data: PropTypes.shape({
        lever: PropTypes.object,
    }).isRequired,
    location: PropTypes.object.isRequired,
}

export default Career

export const postQuery = graphql`
    query($careerId: String!) {
        lever(lever_id: { eq: $careerId }) {
            id
            description
            descriptionPlain
            text
            applyUrl
            lists {
              content
              text
            }
            categories {
              team
              location
              commitment
            }
        }
    }
`
